module.exports = __webpack_public_path__ + "components/carousel-photo-gallery/static/generic-bg--5-b195416203f8b4d20e5724eaa0d21714.jpg";